<template>
  <div class="basic-layout">
    <LayoutHeader />
    <!-- 判断是否命中了显示行业专区 -->
    <div class="layout-body" :class="{ show_industry_zone: isShowIndustryZone }">
      <LayoutBreadcrumb />
      <div class="grid" :style="{ position: checkForSlotContent && isShowMenu ? 'relative' : '' }">
        <LayoutMenu v-if="isShowMenu" />
        <div id="container">
          <slot></slot>
        </div>
        <div v-if="checkForSlotContent && isShowMenu" class="overall-situation-skeleton">
          <div>
            <el-skeleton class="el-skeleton-box" animated :count="2">
              <template slot="template">
                <el-skeleton-item variant="text" class="skeleton-item" />
              </template>
            </el-skeleton>
          </div>
          <div>
            <el-skeleton class="el-skeleton-box" animated :count="3">
              <template slot="template">
                <el-skeleton-item variant="text" :style="{ height: '100px' }" class="skeleton-item" />
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>
    </div>
    <LayoutSidebar v-if="isShowSidebar" />
    <LayoutFooter v-if="isShowFooter" />
  </div>
</template>

<script>
import LayoutHeader from "@/layouts/LayoutHeader";
import LayoutBreadcrumb from "@/layouts/LayoutBreadcrumb";
import LayoutMenu from "@/layouts/LayoutMenu";
import LayoutSidebar from "@/layouts/LayoutSidebar";
import LayoutFooter from "@/layouts/LayoutFooter";
import { TITLE } from "@/utils/constants/constants";

export default {
  name: "BasicLayout",
  components: {
    LayoutHeader,
    LayoutBreadcrumb,
    LayoutMenu,
    LayoutSidebar,
    LayoutFooter,
  },
  computed: {
    pageTitle() {
      return this.$store.getters["layout/pageTitle"];
    },
    isShowMenu() {
      return this.$store.getters["layout/isShowMenu"];
    },
    isShowSidebar() {
      const sidebar = this.$store.getters["layout/sidebar"];
      return sidebar && sidebar.show;
    },
    isShowFooter() {
      return this.$store.getters["layout/isShowFooter"];
    },
    isShowIndustryZone() {
      return this.$store.getters["industryZone/isShowIndustryZone"];
    },
  },
  watch: {
    pageTitle: {
      handler(newV) {
        document.title = newV + " - " + TITLE;
      },
      immediate: true,
    },
  },
  data() {
    return {
      checkForSlotContent: true,
    };
  },
  mounted() {
    let _this = this;
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    this.observer = new MutationObserver(function (mutations) {
      mutations.forEach(function () {
        _this.checkForSlotContent = false;
        _this.observer.disconnect();
      });
    });
    const config = { childList: true }; // 传入目标节点和观察选项
    this.observer.observe(document.getElementById("container"), config);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
</script>

<style scoped lang="scss">
@import "../assets/config.scss";

.basic-layout {
  width: 100%;
  min-width: $layout-body-width;
  background-color: $theme-bg-color;

  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .layout-body {
    width: $layout-body-width;
    margin: 0 auto;

    .grid {
      min-height: 500px;
      display: flex;
    }
    .overall-situation-skeleton {
      width: calc(100% - 240px);
      height: 100%;
      position: absolute;
      top: 0;
      left: 240px;
      & > div {
        background-color: #fff;
        margin-bottom: 20px;
      }
    }
  }
  #container {
    width: 100%;
  }
  .show_industry_zone {
    padding-top: calc(#{$industry-zone-height} - #{$layout-header-height});
  }
  .el-skeleton-box {
    padding: 20px;
  }
  .skeleton-item {
    height: 30px;
    margin: 10px 0;
  }
}
</style>
